export default __webpack_public_path__ + "static/media/popout.2c071577.svg";